export default [
  function () {
    this.isVisible = true;
    this.onClosePopup = this.onClose || angular.noop;

    this.close = () => {
      this.isVisible = false;
      this.onClose();
    };
  },
];
